import developmentConfig from './development';
import stagingConfig from './staging';
import productionConfig from './production';

const environment = process.env.NODE_ENV;
const development = process.env.NODE_ENV === 'development';
const Production = process.env.NODE_ENV === 'production';

let environmentConfig;
switch (environment) {
  case 'development':
    environmentConfig = developmentConfig;
    break;
  case 'staging':
    environmentConfig = stagingConfig;
    break;
  case 'production':
    environmentConfig = productionConfig;
    break;
  default:
    environmentConfig = developmentConfig;
    break;
}

const configuration = { ...environmentConfig, isProduction: Production, isDevelopment: development };
export default configuration;
